// Copyright (C) 2025-2026 Skylark Drones

import { v1EventGatewayInstance } from '@/config'

/**
 * Give command to the dock to perform a action
 *
 * @param {String} commandKey dock command key
 * @returns
 */
export function callCommand(dockSn, commandKey, payload) {
  return v1EventGatewayInstance.http.post(
    `docks/${dockSn}/services/command/${commandKey}`,
    { [commandKey]: payload }
  )
}

export function updateDeviceProperty(dockSn, payload) {
  return v1EventGatewayInstance.http.post(`docks/${dockSn}/properties`, payload)
}
